import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "../../../components/Modal/Modal";
import MemberCard from "./MemberCard";

export default function CommissionDetailsModal({ isOpen, onClose, commission, members = [] }) {
  if (!commission) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" labelledById="commission-modal-title">
      <ModalHeader
        id="commission-modal-title"
        title={commission?.nom_commission || "Commission"}
        subtitle={commission?.description_commission || "Détails de la commission"}
        onClose={onClose}
      />
      <ModalBody>
        {members.length === 0 ? (
          <div className="rounded-2xl p-6 text-center ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white/90 dark:bg-slate-800/80">
            Aucun membre rattaché pour le moment.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {members.map((m) => (
              <MemberCard key={m.id} p={m} compact />
            ))}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-primary" data-autofocus onClick={onClose} type="button">
          Fermer
        </button>
      </ModalFooter>
    </Modal>
  );
}
